export default __webpack_public_path__ + "static/media/img-0066-uk-full-face.b2e289f4.png";